import React, { useState } from 'react';
import SupportEngineLoader from './components/SupportEngineLoader';
import SupportEngineLayout from './layout/SupportEngineLayout';
import './styles/support-engine.css';

const SupportEngineApp = () => {
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  return (
    <div className="support-engine-root-container">
      {isInitialLoading && <SupportEngineLoader />}
      <SupportEngineLayout onInitialReady={() => setIsInitialLoading(false)} />
    </div>
  );
};

export default SupportEngineApp;
